import { User } from '../../apis/graphql/types';
import { UserFieldName } from '../../pages/AccountManagement/Users/types';

export type UserInfo = Pick<
  User,
  'assignments' | 'email' | 'firstName' | 'lastName' | 'id' | 'phone' | 'roleList' | 'status'
>;

export const ROLES = {
  admin: 'Organization Admin',
  manager: 'Creative Manager',
  member: 'Organization Member',
  adAccountAdmin: 'Ad Account Admin',
  adAccountAnalyst: 'Ad Account Analyst',
  buyer: 'Buyer',
  analyst: 'Analyst',
  marketerAnalyst: 'Marketer Analyst',
};

export const FIRST_NAME: UserFieldName = 'firstName';
export const LAST_NAME: UserFieldName = 'lastName';
export const EMAIL: UserFieldName = 'email';
export const ORGANIZATION_ROLE: UserFieldName = 'organizationRole';

export const defaultName = 'Name';
export const defaultLastName = 'Lastname';
